/**
 * FiscalHub — Batch #14.114
 *
 * Hub "poupée russe" du sidebar > Fiscal.
 * Affiche 5 tuiles colorées qui ouvrent les modules fiscaux existants.
 */
import { useNavigate } from "react-router-dom";
import {
  Landmark, FolderTree, Hash, Percent, Library,
} from "lucide-react";
import { TONE_BG } from "@/constants/tones";

const TILES = [
  { id: "dossiers",    title: "Fiscal",                  desc: "Dossiers fiscaux",        icon: FolderTree,        path: "/admin/fiscal-dossiers",       tone: "indigo" },
  { id: "tax-lines",   title: "Lignes fiscales",         desc: "Saisie ligne par ligne",  icon: Hash,              path: "/admin/tax-lines",             tone: "blue" },
  { id: "tax-lines-base", title: "Base lignes fiscales", desc: "Référentiel des lignes",  icon: Library,           path: "/admin/tax-lines?view=base",   tone: "cyan" },
  { id: "tax-rates",   title: "Taux d'imposition",       desc: "Taux fédéraux & provinciaux", icon: Percent,       path: "/admin/tax-rates",             tone: "amber" },
];


export default function FiscalHub() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6 p-4 sm:p-6 max-w-6xl mx-auto" data-testid="fiscal-hub">
      {/* Header */}
      <div className="bg-gradient-to-r from-indigo-50 via-indigo-50 to-white border-2 border-indigo-200 rounded-2xl p-5 sm:p-6 shadow-sm">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-indigo-600 text-white flex items-center justify-center shadow">
            <Landmark className="w-6 h-6" />
          </div>
          <div>
            <h1 className="text-lg sm:text-xl font-bold text-slate-900">Fiscal</h1>
            <p className="text-xs text-slate-600 mt-0.5">
              Outils fiscaux — sélectionnez un module pour commencer.
            </p>
          </div>
        </div>
      </div>

      {/* Grille tuiles */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
        {TILES.map((t) => (
          <button
            key={t.id}
            onClick={() => navigate(t.path)}
            className={`group bg-gradient-to-br ${TONE_BG[t.tone]} border-2 rounded-2xl p-5 flex flex-col items-center justify-center text-center transition-all duration-200 transform hover:scale-105 active:scale-95 hover:shadow-lg`}
            data-testid={`fiscal-hub-tile-${t.id}`}
          >
            <div className="w-14 h-14 rounded-2xl bg-white shadow-sm flex items-center justify-center mb-3 group-hover:shadow-md transition">
              <t.icon className="w-7 h-7" />
            </div>
            <span className="font-semibold text-sm mb-0.5">{t.title}</span>
            <span className="text-[10px] opacity-75">{t.desc}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
